import axios from 'axios'

export default {
    getAll: () => axios.get('/stock_register'),
    getById: id => axios.get(`/stock_register/${id}`),
    getLastActive: () => axios.get(`/stock_register/last_active`),
    create: formData => axios.post(`/stock_register/create`, formData),
    changeStatus: formData => axios.patch(`/stock_register/toggle_status`, formData),
    edit: formData => axios.put(`/stock_register/edit`, formData),
    delete: id => axios.delete(`/stock_register/delete/${id}`)
}